// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportedFuncCache32;
var wasmImportObjects = {
	6439: function() {
		return {
			"./digital_instruments_bg.js": {
				"__wbg_close_5a97ef05b337f8ce": function(p0externref) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache0["ei"](p0externref);
				},
				"__wbg_eval_e10dc02e9547f640": function(p0i32,p1i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache1["kj"](p0i32,p1i32);
				},
				"__wbindgen_boolean_get": function(p0externref) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache2["Nh"](p0externref);
				},
				"__wbg_new_405e22f390576ce2": function() {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache3["v"]();
				},
				"__wbg_setsamplerate_8bc3fd769a6db02b": function(p0externref,p1f32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache4["W2"](p0externref,p1f32);
				},
				"__wbg_newwithcontextoptions_b62c06fed7900366": function(p0externref) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache5["lJ"](p0externref);
				},
				"__wbg_destination_6400091abd6f01b3": function(p0externref) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache6["u_"](p0externref);
				},
				"__wbg_maxChannelCount_a06f8ca4190698ed": function(p0externref) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache7["oN"](p0externref);
				},
				"__wbg_setchannelCount_876fcf5798895180": function(p0externref,p1i32) {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache8["NZ"](p0externref,p1i32);
				},
				"__wbg_createBuffer_926beeec3ff39b5a": function(p0externref,p1i32,p2i32,p3f32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache9["bF"](p0externref,p1i32,p2i32,p3f32);
				},
				"__wbindgen_cb_drop": function(p0externref) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache10["LC"](p0externref);
				},
				"__wbg_suspend_6011a41599f07de4": function(p0externref) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache11["ie"](p0externref);
				},
				"__wbg_instanceof_Window_def73ea0955fc569": function(p0externref) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache12["vF"](p0externref);
				},
				"__wbg_resume_35efdc4ffe13bf18": function(p0externref) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache13["gv"](p0externref);
				},
				"__wbg_setTimeout_f2fe5af8e3debeb3": function(p0externref,p1externref,p2i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache14["GM"](p0externref,p1externref,p2i32);
				},
				"__wbg_currentTime_adef4d803f58eb66": function(p0externref) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache15["Ax"](p0externref);
				},
				"__wbg_copyToChannel_b81ecf19fd54e146": function(p0externref,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache16["yk"](p0externref,p1i32,p2i32,p3i32);
				},
				"__wbg_createBufferSource_f7860a96f709acbd": function(p0externref) {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache17["TE"](p0externref);
				},
				"__wbg_setbuffer_10a9ee2a05c73896": function(p0externref,p1externref) {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache18["og"](p0externref,p1externref);
				},
				"__wbg_connect_b22945d106632a36": function(p0externref,p1externref) {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache19["Vx"](p0externref,p1externref);
				},
				"__wbg_setonended_00ff85c70a4f819f": function(p0externref,p1externref) {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache20["aw"](p0externref,p1externref);
				},
				"__wbg_start_e81f89e130c3c86e": function(p0externref,p1f64) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache21["rZ"](p0externref,p1f64);
				},
				"__wbindgen_is_undefined": function(p0externref) {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache22["vU"](p0externref);
				},
				"__wbg_newnoargs_105ed471475aaf50": function(p0i32,p1i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache23["Vr"](p0i32,p1i32);
				},
				"__wbg_call_672a4d21634d4a24": function(p0externref,p1externref) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache24["wH"](p0externref,p1externref);
				},
				"__wbg_static_accessor_GLOBAL_88a902d13a557d07": function() {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache25["ii"]();
				},
				"__wbg_static_accessor_GLOBAL_THIS_56578be7e9f832b0": function() {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache26["w6"]();
				},
				"__wbg_static_accessor_WINDOW_5de37043a91a9c40": function() {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache27["x0"]();
				},
				"__wbg_static_accessor_SELF_37c5d418e4bf5819": function() {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache28["fb"]();
				},
				"__wbindgen_debug_string": function(p0i32,p1externref) {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache29["rl"](p0i32,p1externref);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache30["Qn"](p0i32,p1i32);
				},
				"__wbindgen_closure_wrapper68": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache31["FD"](p0i32,p1i32,p2i32);
				},
				"__wbindgen_init_externref_table": function() {
					if(wasmImportedFuncCache32 === undefined) wasmImportedFuncCache32 = __webpack_require__.c[191].exports;
					return wasmImportedFuncCache32["bL"]();
				}
			}
		};
	},
};

var wasmModuleMap = {
	"245": [
		6439
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"245":{"6439":"3e196d6532268c42956f"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};